export const resources = {
  common: {
    appName: "Axetay Harbour",
    appTagline: "Secure asset ingestion & management pipeline",
    backToAssets: "Back to Assets",
    loading: "Loading...",
    exportCsv: "Export CSV",
    metadataJson: "Metadata JSON",
    searchPlaceholder: "Search by name, ID, or path...",
    clearFilters: "Clear all filters",
    noAssetsFound: "No assets found matching your criteria.",
    live: "Live",
  },
  navigation: {
    dashboard: "Dashboard",
    assets: "Assets",
    identificationRules: "Identification Rules",
    settings: "Settings",
    logout: "Logout",
    userRole: "Data Ops Lead",
  },
  login: {
    title: "Axetay Harbour",
    tagline: "Secure asset ingestion & management pipeline",
    signIn: "Sign in",
    signInLoading: "Redirecting...",
    legalNote: "By signing in, you agree to Axetay's Terms of Service and Privacy Policy.",
  },
  dashboard: {
    title: "System Overview",
    subtitle: "Monitoring Axetay Harbour ingestion pipeline",
    stats: {
      totalAssets: "Total Assets",
      receivedToday: "Received Today",
      activeProcessing: "Active Processing",
      failedAssets: "Failed Assets",
    },
    activity: {
      title: "Recent Activity",
      viewAll: "View all assets",
    },
    quickFilters: {
      title: "Quick Filters",
      today: "Today",
      thisWeek: "This Week",
      errors: "Errors Only",
      queue: "Identify Queue",
    },
  },
  assetsList: {
    title: "Asset Explorer",
    subtitle: "Search and filter through historical ingestion data",
    filters: "Filters",
    table: {
      fileName: "File Name",
      type: "Type",
      status: "Status",
      size: "Size",
      received: "Received",
    },
    pagination: {
      showing: "Showing",
      to: "to",
      of: "of",
      assets: "assets",
    },
  },
  assetDetail: {
    storageInfo: "Storage Information",
    sourceUri: "Source URI",
    stagedUri: "Staged URI",
    assetId: "Asset ID (Hash)",
    bucket: "S3 Bucket",
    processingHistory: "Processing History",
    footerInfo: (state: string) => `This asset has been processed by the Axetay Harbour pipeline. It is currently in the ${state} state.`,
    labels: {
      size: "Size",
      received: "Received",
      storage: "Storage",
      events: "Events",
    },
  },
  identificationRules: {
    title: "Identification Rules",
    subtitle: "Path prefix rules used to classify incoming assets by file type",
    table: {
      pathPrefix: "Path Prefix",
      fileType: "File Type",
    },
    summary: (count: number) => `${count} rule${count !== 1 ? 's' : ''} configured`,
    noRules: "No identification rules are configured.",
    loading: "Loading identification rules…",
    loadError: "Failed to load identification rules.",
  },
  settings: {
    title: "Settings",
    placeholder: "Configuration options for ingestion pipelines and webhooks will be available in Phase 2.",
  },
};
